<template>
  <confirm-dialog
    v-show="isShow"
    :data="dialogData"
    name="albumPickerModal"
    @confirm="handleConfirm"
  >
    <div class="album-picker-modal row">
      <draggable
        :list="imageUrls"
        ghost-class="ghost"
        class="list-group first"
      >
        <div
          v-for="(imageUrl, index) in imageUrls"
          :key="imageUrl"
          class="position-relative ms-3 mt-3"
        >
          <div class="image">
            <span
              class="position-absolute album-remove pointer"
              @click="removeImage(index)"
              >&times;</span
            >
            <a :href="imageUrl" target="_blank" draggable="false">
              <img :src="imageUrl" alt="" class="photo" draggable="false" />
            </a>
          </div>
        </div>
      </draggable>
      <div v-if="!limit || imageUrls.length < limit">
        <div
          v-if="dimension"
          class="upload-box ms-3 mt-3"
          @click="openImageSelector"
        >
          <img src="/static/icons/button-add-cover.svg" alt="" />
        </div>
        <div v-else class="upload-box ms-3 mt-3">
          <image-upload-and-resize
            v-bind="chooseImageFullDimensionDialog"
            @confirm="addImageAlbum"
          ></image-upload-and-resize>
        </div>
      </div>
    </div>
    <div class="remake">ขนาดไฟล์สูงสุดคือ {{ maxFileSizeMB || "1" }} MB</div>
    <div v-if="!isFreeSizeImage">
      <image-picker-modal
        v-bind="chooseImageDialog"
        @cancel="handleCancelChooseImage"
        @confirm="addImageAlbum"
      ></image-picker-modal>
    </div>
    <div v-else>
      <image-picker-free-size-modal
        v-bind="chooseImageDialog"
        :dimension="dimension"
        @cancel="handleCancelChooseImage"
        @confirm="addImageAlbum"
      ></image-picker-free-size-modal>
    </div>
  </confirm-dialog>
</template>

<script>
import { isEmpty, isNil } from "ramda";
import draggable from "vuedraggable";
import { uploadPublicImage, uploadImageAndGetUrlAndKey } from "@/god";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import ImageUploadAndResize from "@/lib/components/ImageUploadAndResize";
import ImagePickerFreeSizeModal from "@/lib/components/ImagePickerFreeSizeModal";

export default {
  name: 'AlbumAndSwipePicker',
  components: {
    draggable,
    ImagePickerModal,
    ImageUploadAndResize,
    ImagePickerFreeSizeModal,
  },
  props: {
    title: { type: String, default: null },
    canEdit: { type: Boolean, default: true },
    isShow: { type: Boolean, default: false },
    album: { type: Array, default: () => [] },
    imageName: { type: String, default: null },
    remark: { type: Object, default: null },
    dimension: { type: Object, default: null },
    titleForChooseImage: { type: String, default: null },
    pathImage: { type: String, default: null },
    isNotMakePublicImage: { type: Boolean, default: false },
    limit: { type: Number, default: null },
    maxFileSizeMB: { type: Number, default: null },
    isFreeSizeImage: { type: Boolean, default: false },
  },
  data() {
    return {
      imageUrls: [],
      isShowImageModal: false,
    };
  },
  computed: {
    dialogData() {
      return {
        title: this.title,
        buttonCancel: "ยกเลิก",
        buttonSubmit: "บันทึก",
        disableSubmit: false,
        disableCancel: false,
        hideAction: false,
        remark: this.remark && this.remark.firstRemark,
        secondRemark: this.remark && this.remark.secondRemark,
      };
    },
    chooseImageDialog() {
      const baseDialog = {
        isLoading: false,
        canEdit: true,
        title: this.titleForChooseImage || "เลือกรูป",
        thumbnailFile: null,
        thumbnailUrl: null,
      };

      if (this.isFreeSizeImage) {
        return {
          ...baseDialog,
          isShow: this.isShowImageModal,
          width: this.dimension ? this.dimension.width : undefined,
          height: this.dimension ? this.dimension.height : undefined,
          recommendWidth: this.dimension
            ? this.dimension.recommendWidth
            : undefined,
          recommendHeight: this.dimension
            ? this.dimension.recommendHeight
            : undefined,
          maxFileSizeMB: this.maxFileSizeMB || 1,
        };
      }

      return {
        ...baseDialog,
        isShow: this.isShowImageModal && this.dimension,
        width: (this.dimension && this.dimension.width) || 300,
        height: (this.dimension && this.dimension.height) || 200,
        recommendWidth:
          (this.dimension && this.dimension.recommendWidth) || 1200,
        recommendHeight:
          (this.dimension && this.dimension.recommendHeight) || 800,
      };
    },
    chooseImageFullDimensionDialog() {
      return {
        isPreviewImage: false,
      };
    },
  },
  watch: {
    album(newValue) {
      this.imageUrls = !(isNil(newValue) || isEmpty(newValue))
        ? newValue
        : [];
    },
  },
  methods: {
    async addImageAlbum(file) {
      if (isNil(file)) {
        return;
      }

      const maxSize = this.maxFileSizeMB || 1;
      if (file.size / 1024 / 1024 > maxSize) {
        this.$message.error(`รูปขนาดเกิน ${maxSize} MB ไม่สามารถอัพโหลดได้`);
        return;
      }

      // NOTE: use uploadImageAndGetUrlAndKey to get key for token-gated access
      const imageUrl = this.isNotMakePublicImage
        ? await uploadImageAndGetUrlAndKey(file, this.imageName, this.pathImage)
        : await uploadPublicImage(file, this.imageName, this.pathImage);

      this.imageUrls.push(imageUrl);

      this.isShowImageModal = false;
    },
    removeImage(imagePosition) {
      this.imageUrls = this.imageUrls.filter(
        (url, index) => index !== imagePosition
      );
    },
    openImageSelector() {
      this.isShowImageModal = true;
    },
    handleConfirm(isConfirm) {
      if (!isConfirm) {
        const imageUrls = !(isNil(this.album) || isEmpty(this.album))
          ? this.album
          : [];

        this.imageUrls = imageUrls;

        this.$emit("cancel");
        return;
      }

      const mainImage =
        this.imageUrls && this.imageUrls.length > 0
          ? this.imageUrls[0]
          : undefined;

      if (this.imageUrls && this.imageUrls.length > 1) {
        this.imageUrls.shift();
      } else {
        this.imageUrls = [];
      }

      const allImageToAlbum = mainImage
        ? [mainImage, ...this.imageUrls]
        : [];

      this.imageUrls = allImageToAlbum;

      this.$emit("confirm", {
        packageAlbums: this.imageUrls,
        allImageToAlbum,
        imageFile: mainImage,
      });
    },
    handleCancelChooseImage() {
      this.isShowImageModal = false;
    },
  },
};
</script>

<style lang="scss">
.album-picker-modal {
  border: 2px dashed #d8d6d9;
  line-height: 1.21;
  letter-spacing: normal;
  color: #8c8786;

  margin: 0 auto;
  overflow: auto;
  width: 550px;
  height: 400px;
}

.photo {
  width: 148px;
  height: 148px;
  border-radius: 16px;
  border: hidden;
  object-fit: cover;

  &.added {
    border: 1px solid #e0e0e0;
  }
}

.upload-box {
  width: 148px;
  height: 148px;
  border-radius: 16px;
  border: 2px dashed #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.setting-body {
  padding: 20px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.album-remove {
  top: 5px;
  right: 5px;
  background: #aaa;
  border-radius: 50%;
  border: 2px solid $white;
  width: 20px;
  height: 20px;
  padding: 3px;

  font-size: 16px;
  color: $white;
  line-height: 0.5;
}

.remake {
  font-size: 11px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
  margin-top: 16px;
  text-align: center;
}

.input-file {
  opacity: 0;
  position: absolute;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.first {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  text-align: center;
}

.list-group-item {
  width: 100% !important;
}

.image {
  cursor: pointer;
}
</style>
